var angular = require('angular');
var _module = angular.module('benoit');
var _ = require('lodash');
var simpleCypher = require('../../../libs/simple-cypher');

require('../../filters');
require('../../services/analytics');
require('../../services/user');
require('../../services/activity-feed');
require('../../services/lr-touch');

_module.controller('PrequalifyButtonCtrl', [
    '$log',
    '$element',
    '$attrs',
    '$user',
    '$activityFeed',

    function PrequalifyButtonCtrl($log, $element, $attrs, $user, $activityFeed) {
        $log.debug('PrequalifyButtonCtrl', this);

        var vm = this;
        vm.model = {
            extrapadding: $attrs.hasOwnProperty('extrapadding'),
            affiliate: $user.affiliate,
            matchScore: 'N/A',
            decodedListingId: undefined,
            decodedListingSource: undefined
        };
        vm.events = {
            onClick: onClick
        };

        // Lifecycle Hooks
        vm.$onInit = init;

        // Functions
        function onClick() {
            var lo = (vm.model.affiliate.benoit_partner && vm.model.affiliate.benoit_partner.website)
                    ? vm.model.affiliate.benoit_partner : vm.model.affiliate;

            if(lo && $user.account_type !== 'guest') {
                var postData = {
                    address: vm.listing.address,
                    lo_name: lo.name,
                    lo_phone: lo.phone,
                    lo_email: lo.email
                };

                $user.sendPreQualifyClickedNotifications(postData)
                .then(function (response) {
                    $log.debug('Prequalify Notifications Success!', response);

                    if($user.account_type !== 'guest') {
                        $activityFeed.add({
                            avatar: 'initials',
                            type: 'lead',
                            name: 'benoit_user_click_prequalify_button',
                            userId: $user.affiliateId,
                            meta: {
                                benoitPartnerId: $user.affiliate.benoitPartnerId,
                                benoitUserId: $user.id,
                                name: $user.full_name,
                                first_name: $user.first_name,
                                last_name: $user.last_name,
                                phone: $user.phone,
                                email: $user.email,
                                address: vm.listing.address,
                                listingId: vm.model.decodedListingId,
                                listing_source: vm.listing.listing_source,
                                filterId: vm.filterId
                            }
                        });
                    }
                })
                .catch(function (err) {
                    $log.error('Prequalify Notifications Error!', err);
                });
            }
        }

        function getFilterAndSetMatchScore() {
            if(vm.filterId && vm.listing) {
                $user.getSearchFilter(vm.filterId)
                .then(function setMatchScore(filter) {
                    vm.model.matchScore = filter.rankListing(vm.listing);
                });
            }
        }

        function decodeListingId() {
            var decoded = simpleCypher.decode(vm.listing.id);

            if(decoded && decoded.id && decoded.source) {
                vm.model.decodedListingId = decoded.id;
                vm.model.decodedListingSource = decoded.source;
            }else {
                $log.error('Decode ID error', decoded);
            }
        }

        function checkIfShouldBeHidden() {
            var benoitPartner = _.get($user, 'affiliate.benoit_partner');
            var benoitPartnerWebsite = _.get(benoitPartner, 'website');
            var affiliateWebsite = _.get($user, 'affiliate.website');

            if(benoitPartnerWebsite || (!benoitPartner && affiliateWebsite)) {
                return true;
            } else {
                $element.css('display', 'none');
                return false;
            }
        }

        function init() {
            if(_.get(vm, 'listing.id', null)) {
                decodeListingId();
            }
            if(!checkIfShouldBeHidden()) {
                getFilterAndSetMatchScore();
            }
        }
    }
]);

_module.component('prequalifyButton', {
    template: require('./index.html'),
    controllerAs: 'vm',
    controller: 'PrequalifyButtonCtrl',
    bindings: {
        listing: '<',
        filterId: '@',
        source: '@'
    }
});
